<template>
  <div class="main">
    <el-dialog
        custom-class="ai-gen-task"
        title="AI 任务分解"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
      <div v-loading="loading" :element-loading-text="loadingText">
        <div class="title-head">
          <div class="name">标题</div>
          <div class="s-date">起始时间</div>
          <div class="e-date">截止时间</div>
        </div>
        <div class="parent">

          <vab-remix-icon icon-class="download_1" class="ver-middle fz-14 icon-close "/>

          <div class="name">
            <el-input ref="parentNameInput" v-model="name" placeholder="添加标题"
                      @keyup.enter.native="saveParentName" @blur="saveParentName"></el-input>
          </div>
          <div class="btn-ai pointer" @click="genTask">
            <svg-icon icon-class="robot"
            ></svg-icon>

            <!--            <vab-remix-icon icon-class="robot"-->
            <!--                            class="ver-middle fz-18 m-r-2"/>-->
            <div>重新分解</div>
          </div>
          <div class="s-date">
            <el-date-picker
                v-model="startDate"
                prefix-icon="ss"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                placeholder="添加日期"
                type="date">
            </el-date-picker>
          </div>
          <div class="e-date">
            <el-date-picker
                v-model="endDate"
                prefix-icon="ss"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                placeholder="添加日期"

                type="date"></el-date-picker>
          </div>
        </div>
        <div class="child-list">
          <draggable v-model="tasks"
                     :disabled="isMobile ? true : false"
                     chosen-class="chosen"
                     class="draggable"
                     force-fallback="true"
                     handle=".mover"
                     animation="100">
            <div class="item mover" v-for="(item, index)  in tasks" :key="index">
              <div class="name">
                <el-input ref="nameInput" v-model="item.name" placeholder="添加标题"
                          @keyup.enter.native="saveName(index)"></el-input>
              </div>
              <div class="s-date">
                <el-date-picker
                    v-model="item.start"
                    prefix-icon="ss"
                    value-format="yyyy/MM/dd"
                    format="yyyy/MM/dd"
                    placeholder="添加日期"
                    @change="changeDate(index, 1)"
                    type="date"></el-date-picker>
              </div>
              <div class="e-date">
                <el-date-picker
                    v-model="item.end"
                    prefix-icon="ss"
                    value-format="yyyy/MM/dd"
                    format="yyyy/MM/dd"
                    placeholder="添加日期"
                    @change="changeDate(index, 0)"
                    type="date"></el-date-picker>
              </div>
              <img src="../../../assets/images/trash.png" class="icon-del" @click="deleteOne(index)">
            </div>
          </draggable>
        </div>
        <div class="btn-add" @click="addOne"> + 新建</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>

import {aiGen, edit, importTask} from "@/api/planMaster"
import draggable from 'vuedraggable'

export default {
  props: ['uuid'],
  components: {draggable},
  data() {
    return {
      dialogVisible: false,
      tid: '',
      tasks: [
        {name: '2222', start: '', end: ''},
      ],
      loading: false,
      name: '',
      startDate: '',
      endDate: '',
      curIndex: -1,
      isSubmitting: false,
      loadingText: '',
      isStage: 0,
      color: '',
      isMobile: false,
    }
  },
  created() {
    if (window.screen.width < 500) {
      this.isMobile = true
    }
  },
  watch: {
    tid(e) {

    },
    startDate: {
      handler(newVal, oldVal) {
        if (newVal == oldVal) {
          return false
        }
        if (this.endDate && this.startDate && this.startDate > this.endDate) {
          this.$message({
            type: 'warning',
            message: '开始日期必须小于截止日期',
          })
          this.startDate = oldVal
          return false
        }
        this.editBase('start_date', newVal)
      }
    },
    endDate: {
      handler(newVal, oldVal) {
        if (newVal == oldVal) {
          return false
        }
        if (this.endDate && this.startDate && this.startDate > this.endDate) {
          this.$message({
            type: 'warning',
            message: '开始日期必须小于截止日期',
          })
          this.endDate = oldVal
          return false
        }
        this.editBase('end_date', newVal)
      }
    },

  },
  methods: {
    //show
    show: function (tid, name, startDate, endDate, isStage, color) {
      this.tasks = []
      this.dialogVisible = true
      this.tid = tid
      this.name = name
      this.startDate = startDate
      this.endDate = endDate
      this.isStage = isStage
      this.color = color
      this.genTask()
    },
    // 展示loading 的text
    showLoadingText(i) {
      switch (i) {
        case 1:
          this.loadingText = '收集并整理项目数据'
          break;
        case 2:
          this.loadingText = '上传并提交到AI系统进行深度分析'
          break;
        case 3:
          this.loadingText = 'AI系统正在处理和分析数据'
          break;
        default:
          this.loadingText = '正在返回结果，这可能需要一些时间，请您耐心等待...'
      }
      if (i > 3) {
        return false
      }
      setTimeout(() => {
        this.showLoadingText(i + 1)
      }, 2000);
    },
    //close
    handleClose: function () {
      this.$emit('freshList')
      this.dialogVisible = false
    },
    //分解任务
    genTask: function () {
      this.loading = true
      this.showLoadingText(1)

      aiGen({id: this.tid}, this.uuid).then((res) => {
        if (res.code == -3) {
          this.$refs.limitDialog.open(3)
          this.loading = false
          return false
        }
        this.tasks = res.data.list
        this.loading = false
      }).catch((e) => {
        this.loading = false
      })

    },
    //删除任务
    deleteOne: function (index) {
      this.tasks.splice(index, 1)
    },
    //校验日期
    changeDate: function (index, isStart) {
      let item = this.tasks[index]
      //判断是否在父任务区间
      if (isStart == 1) {
        console.log(this.startDate)
        console.log(this.endDate)
        console.log(item.start)
        console.log(item.end)
        if ((this.startDate && item.start < this.startDate) || (this.endDate && item.start > this.endDate)) {
          this.$message({
            type: 'warning',
            message: '开始日期不能超出父任务的时间范围',
          })
          this.tasks[index].start = ''
          return false
        }
      } else {
        if ((this.startDate && item.end < this.startDate) || (this.endDate && item.end > this.endDate)) {
          this.$message({
            type: 'warning',
            message: '截止日期不能超出父任务的时间范围',
          })
          this.tasks[index].end = ''
          return false
        }
      }
      //start >= end
      if (item.start && item.end && item.start > item.end) {
        this.$message({
          type: 'warning',
          message: '开始日期必须小于截止日期',
        })
        if (isStart == 1) {
          this.tasks[index].start = ''
          return false
        } else {
          this.tasks[index].end = ''
          return false
        }
      }
    },
    //新建任务
    addOne: function () {
      this.tasks.push({
        name: '',
        start: '',
        end: ''
      })
      this.showEditName(this.tasks.length - 1)
    },
    //编辑标题
    showEditName: function (index) {
      this.curIndex = index
      this.$nextTick(() => {
        this.$refs.nameInput[index].focus()
      })
    },
    saveName: function (index) {
      this.curIndex = -1
      this.$refs.nameInput[index].blur()
    },
    //编辑父任务标题，时间
    editBase: function (field, value) {
      edit({id: this.tid, field: field, value: value}, this.uuid).then((res) => {
      })
    },
    showEditParentName: function () {
      this.$nextTick(() => {
        this.$refs.parentNameInput.focus()
      })
    },
    // saveParentName
    saveParentName: function () {
      this.editBase('name', this.name)
    },
    //提交
    submit: function () {
      if (this.isSubmitting == true) {
        return false
      }
      if (this.tasks.length == 0) {
        return this.$message({
          type: 'warning',
          message: '请先添加任务',
        })
      }
      this.isSubmitting = true
      importTask({id: this.tid, tasks: this.tasks}, this.uuid).then((res) => {
        this.$emit('freshList')
        this.dialogVisible = false
      }).catch((e) => {
        this.isSubmitting = false
      })
    }
  },
}
</script>
<style lang="less">
.ai-gen-task {
  width: 800px !important;
  border-radius: 10px;
  color: #10141B;

  .el-dialog__header {
    padding: 16px 24px 16px 34px;

    .el-icon-close {
      color: #10141B;
    }
  }

  .el-dialog__body {
    padding: 20px 0 20px 0;
  }

  .el-dialog__title {
    font-size: 14px;
    font-weight: 550;
  }

  .el-button--small {
    width: 84px;
    height: 36px;
    border-radius: 10px;
    font-size: 14px;
  }

  .el-button--primary {
    background: #495CF7;
  }

  .el-loading-spinner .circular {
    width: 60px;
    height: 60px;
  }

  .parent .name .el-input__inner {
    padding: 0 0 0 4px;
    font-weight: 550;
    background: #F6F7FB;
  }

  .parent:hover .name .el-input__inner {
    background: #fff;
  }

  /deep/ .name .el-input--small .el-input__inner {
    border: none;
    padding: 0 4px;
    color: #10141B;
  }

  .parent .el-date-editor .el-input__inner {
    background: #F6F7FB;
  }

  .parent:hover .el-date-editor .el-input__inner {
    background: #fff;
  }

  .el-date-editor {

    .el-input__inner {
      padding: 0;
      border: none;
      text-align: center;
      box-sizing: border-box;
      color: #10141B;
    }

    .el-input__suffix {
      right: -8px;
    }

  }
}

</style>
<style lang="less" scoped>
/deep/ input::-webkit-input-placeholder {
  color: #ADB1BA;
}

/deep/ .el-loading-text {
  color: #10141B !important;
  font-size: 13px;
  margin-top: 20px;
}

/deep/ .el-loading-spinner {
  top: 0;
  margin: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .path {
    stroke: #9D40FB;
  }
}


.s-date, .e-date {
  width: 92px;

  display: flex;
  align-items: center;
  justify-content: center;
}

.s-date {
  margin-right: 20px;
}

.title-head {
  display: flex;
  color: #787D86;
  height: 30px;
  font-size: 13px;
  border-bottom: 1px solid var(--normal, #E2E4E9);
  align-items: center;

  .name {
    width: 498px;
    margin: 0 20px 0 46px;
  }
}

.parent {
  display: flex;
  padding: 10px 0;
  height: 50px;
  align-items: center;
  background: #F6F7FB;
  border-bottom: 1px solid var(--normal, #E2E4E9);

  .icon-close {
    width: 16px;
    height: 16px;
    margin: 0 8px 0 10px;

    &.stage {
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      transition: transform 0.3s;
      border-radius: 50%;
    }
  }

  .name {
    width: 410px;
    font-size: 13px;
    font-weight: 550;
  }

  .btn-ai {
    width: 79px;
    height: 30px;
    margin: 0 20px 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    border: 1px solid #E2E4E9;
    color: var(--3, #704FF9);
    font-size: 11px;
    font-weight: 550;
    box-sizing: border-box;

    .svg-icon {
      width: 20px;
      height: 20px;
      margin: 0 2px 0 0;
    }
  }

  &:hover .btn-ai {
    background: #fff;
    color: #704FF9;
  }

}

.child-list {
  .item {
    font-size: 13px;
    display: flex;
    padding: 18px 0 0 46px;
    align-items: center;

    .name {
      width: 498px;
      margin: 0 20px 0 0;
      line-height: 32px;
      border-bottom: 1px solid var(--normal, #E2E4E9);


      .name-label {
        padding: 0 0 0 4px;
        cursor: pointer;
      }

      .empty-name {
        padding: 0 0 0 4px;
        color: #ADB1BA;
      }
    }

    .s-date, .e-date {
      line-height: 32px;
      border-bottom: 1px solid var(--normal, #E2E4E9);
    }

    .icon-del {
      width: 20px;
      height: 20px;
      margin: 0 0 0 2px;
      cursor: pointer;
      opacity: 0;
    }

    &:hover .icon-del {
      opacity: 1;
    }
  }
}

.btn-add {
  width: 706px;
  height: 32px;
  color: #495CF7;
  font-size: 13px;
  margin: 18px 0 0 48px;
  border-radius: 4px;
  background: #F8F9FA;
  display: flex;
  align-items: center;
  padding: 0 0 0 4px;
  box-sizing: border-box;
  cursor: pointer;
}

@media (max-width: 768px) {
  ::v-deep .ai-gen-task {
    width: 90% !important;
  }

  .btn-add {
    width: 85% !important;
    margin: 18px 0 0 5% !important;
  }

  .parent .name {
    width: 70% !important;
    margin-left: 5%;
  }

  .child-list .item {
    padding: 18px 0 0 5% !important;

    .name {
      width: 85% !important;
      margin: 0 10px 0 0 !important;
      padding: 0 0 1px 0;
    }
  }

  .btn-ai {
    margin: 0 10px !important;
  }

  .icon-close {
    display: none !important;
  }

  .title-head {
    display: none !important;
  }

  .s-date {
    display: none !important;
  }

  .e-date {
    display: none !important;
  }
}
</style>